import {
  hasSuperAdminRole,
  hasSupplierManagementAccess,
  hasPmsModuleInRoutes
} from '@/utils/privilegedRoleAccess'

export const SUPPLIER_SUPPLY_ROUTE_NAMES = [
  'supplierProductList',
  'supplierProductAdd',
  'supplierProductUpdate',
  'supplierProductEditMobile'
]

/** 当前路由是否为「供货商品」模块（/supplier/goods*） */
export function isSupplierSupplyProductRoute(route) {
  if (!route) return false
  if (route.meta && route.meta.supplierSupplyMode === true) return true
  const name = route.name
  return SUPPLIER_SUPPLY_ROUTE_NAMES.indexOf(name) !== -1
}

/** 是否具备供货商品能力（⑧ + 有效供应商范围，与后端 supplierManagementAllowed 一致） */
export function canAccessSupplierSupplyProducts(roles, integrationModuleScope) {
  return hasSupplierManagementAccess(roles, integrationModuleScope)
}

/**
 * 是否启用供货商品「受限 UI」（隐藏审核/推荐/删除/独立积分接口等）
 * 超管、商品管理员走完整商品能力，即使在 /supplier/goods 也不受限
 */
export function useSupplierSupplyProductRestrictions(route, roles, integrationModuleScope, routers) {
  if (!isSupplierSupplyProductRoute(route)) return false
  if (hasSuperAdminRole(roles)) return false
  if (hasPmsModuleInRoutes(routers)) return false
  return hasSupplierManagementAccess(roles, integrationModuleScope)
}

export function supplierSupplyAddRoute(restricted) {
  return restricted ? { name: 'supplierProductAdd' } : { path: '/pms/addProduct' }
}

export function supplierSupplyUpdateRoute(restricted, id) {
  const q = { id: String(id) }
  return restricted
    ? { name: 'supplierProductUpdate', query: q }
    : { path: '/pms/updateProduct', query: q }
}

export function supplierSupplyListRoute(restricted) {
  return restricted ? { name: 'supplierProductList' } : { path: '/pms/product' }
}

export function supplierSupplyEditMobileRoute(restricted, id) {
  const q = { id: String(id) }
  return restricted
    ? { name: 'supplierProductEditMobile', query: q }
    : { path: '/pms/editMobileDetail', query: q }
}

/** §4.6：publishStatus=1 时须 verifyStatus=1 */
export function isProductVerifyApproved(verifyStatus) {
  return Number(verifyStatus) === 1
}

export const PRODUCT_PUBLISH_REQUIRES_VERIFY_MSG =
  '商品须经超级管理员审核通过后才能上架，请联系超管审核后再试'



// WEBPACK FOOTER //
// ./src/utils/supplierSupplyProduct.js